import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { AppContextProvider } from './AppContext';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import { FormProgressProvider } from './contexts/FormProgressContext';
import { UserProfileProvider } from './contexts/UserProfileContext';
import { CommunityProvider } from './contexts/CommunityContext';
import { ActivitiesProvider } from './contexts/ActivitiesContext';
import { EventsProvider } from './contexts/EventsContext';
import { VenuesProvider } from './contexts/VenuesContext';
import { NewsProvider } from './contexts/NewsContext';
import appQueryClient, { setupAppQueryClientPersistence } from './queries/queryClient';
import { MotionRoot } from '@liquid-spirit/ui-web/motion';

// Persistence must hydrate the query client BEFORE the provider tree renders.
// The context providers register disabled queries with initialData: [] during
// render, which stamps a fresh dataUpdatedAt; if hydration ran in an effect
// (as it used to), react-query's hydrate() would then discard the persisted
// rows as older, so activities/events never survived a reload.
let queryClientPersistenceStarted = false;
if (typeof window !== 'undefined' && !queryClientPersistenceStarted) {
  queryClientPersistenceStarted = true;
  setupAppQueryClientPersistence(appQueryClient);
}

export const AppProvidersTree = ({ children }) => (
  <MotionRoot>
  <QueryClientProvider client={appQueryClient}>
    <AuthProvider>
      <FormProgressProvider>
        <NotificationsProvider>
          <UserProfileProvider>
            <CommunityProvider>
              <ActivitiesProvider>
                <EventsProvider>
                  <VenuesProvider>
                    <NewsProvider>
                      <AppContextProvider>
                        {children}
                      </AppContextProvider>
                    </NewsProvider>
                  </VenuesProvider>
                </EventsProvider>
              </ActivitiesProvider>
            </CommunityProvider>
          </UserProfileProvider>
        </NotificationsProvider>
      </FormProgressProvider>
    </AuthProvider>
  </QueryClientProvider>
  </MotionRoot>
);

export const AppProviders = ({ children }) => {
  return <AppProvidersTree>{children}</AppProvidersTree>;
};

export default AppProviders;
